import React, { useState } from 'react';
import GConf from '../AssetsM/generalConf';
import axios from 'axios';
import { Button, Input } from 'semantic-ui-react';
import { useNavigate} from 'react-router-dom';
import { toast } from 'react-toastify';

function AddSeanceCard(props) {
    const navigate = useNavigate();
    let [proffData, setProffData] = useState([]);

    const SaveProffFunction = () => {
        if (!props.passedData) {alert('nom')} 
        else if (!props.passedData) {alert('email ')}
        else if (!props.passedData) {alert('matiere')}
        else {
            axios.post(`${GConf.ApiLink}/proff/seance/add`, {
                idp : props.passedData.s_proff,
                seanceData : props.passedData
            })
            .then(function (response) {
                if (response.data.ids) {
                    toast.success("Seance Ajouter  !", GConf.TostSuucessGonf);
                   setTimeout(() => {
                        navigate(`seanceinfo/${response.data.ids}/${props.passedData.s_groupe}`);
                    }, 1000);
                }                 
            })
        }
    }

    return ( <>
            {/* <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Nom du Proff : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_nom: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> E-mail du Proff : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_email: e.target.value })}/>

            <h5 className='text-secondary mb-1'> <span className='bi bi-person'></span> Matiere : </h5>
            <Input  icon='user' iconPosition='left' placeholder='Nom .. ' className='shadow-sm w-100' onChange={(e) => setProffData({...proffData, p_matiere: e.target.value })}/> */}
            <h3 className='mb-3'>Voulez vous ajouter une seance a partir de ces information :  </h3>
            
            <div className='mb-2 text-secondary'> <span className='bi bi-calendar'></span> Date : {props.passedData.s_date} </div>
            <div className='mb-2 text-secondary'> <span className='bi bi-clock-history'></span> Horaire : {props.passedData.s_temps} </div>
            <div className='mb-2 text-secondary'> <span className='bi bi-star-fill'></span> Matiere : {props.passedData.s_matiere} </div>
            <div className='mb-2 text-secondary'> <span className='bi bi-people'></span> Groupe : {props.passedData.s_groupe} </div>
            <div className='mb-2 text-secondary'> <span className='bi bi-houses'></span> Salle : {props.passedData.s_salle} </div>
           
            <div className='mb-3 mt-3'>
                <Button onClick={() => SaveProffFunction()}  style={{backgroundColor: '#262c05', color:'white'}} className='shadow-sm w-100'> Ajouter Seance    </Button>
            </div>
    </> );
}

export default AddSeanceCard;